<template>
  <v-list>
    <v-list-item v-for="(item, index) in items" :key="index" @click="setLocale(item.title)">
      <v-row dense>
        <v-col cols="auto" align="start">
          <v-img :src="require(`../../../../public/flags/flag_${item.title}.png`)" width="30" height="20"></v-img>
        </v-col>

        <v-col cols="auto" align="start">
          {{ item.text }}
        </v-col>
      </v-row>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "LanguageSwitcher",
  data() {
    return {
      items: [
        { title: "cs", text: "Čeština" },
        { title: "en", text: "English" },
        { title: "uk", text: "Українська" },
      ],
    };
  },
  mounted() {
    if (localStorage.getItem("lang") !== null) {
      this.setLocale(localStorage.getItem("lang"));
    }
  },
  methods: {
    setLocale(locale) {
      localStorage.setItem("lang", locale);
      this.$i18n.locale = locale;
      this.$router.push({
        params: { lang: locale },
      });
    },
  },
};
</script>

<style scoped></style>
